<template>
  <div>
    <div class="page-content">
      <ul class="test-wrap" v-if="list">
        <li
          class="list"
          :style="`background-image: url(${item.coverImg})`"
          v-for="(item,index) in list"
          :key="index"
          @click="jumpDetail(item.subject)">
          <div class="content">
            <div class="title">{{item.title}}</div>
            <div class="number">共{{item.subjectNum}}题  需要{{item.subjectNum*3}}秒！</div>
            <div class="popularity">
              <div class="popularity-number">
                {{item.popularity}}人气
              </div>
              <div class="start-btn">
                开始测试
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { funQuestionList } from '@/api/adv';

export default {
  name: 'index',
  data() {
    return {
      pageSize: 1000,
      pageNum: 1,
      list: undefined,
    };
  },
  created() {
    this.getList();
    window.document.title = '趣味测试';
  },
  methods: {
    jumpDetail(data) {
      this.$router.push(
        {
          name: 'ActiveTestDetail',
          query: {
            subject: data,
          },
        },
      );
    },
    getList() {
      const jsonData = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      };
      funQuestionList(jsonData)
        .then((res) => {
          this.list = res.result;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.page-content{
  .test-wrap{
    padding: 40px 14px;
    .list{
      width:717px;
      height:280px;
      border-radius:26px;
      box-shadow: 5px 10px 15px 2px rgba(0,0,0,0.4);
      font-family:PingFangSC-Medium,PingFang SC;
      color:rgba(255,255,255,1);
      background-size: cover;
      overflow: hidden;
      margin-bottom: 38px;
      .content{
        position: relative;
        padding: 25px 28px;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.3);
        .title{
          height:42px;
          font-size:30px;
          font-weight:500;
          line-height:42px;
        }
        .number{
          height:37px;
          font-size:26px;
          font-weight:400;
          line-height:37px;
        }
        .popularity{
          position: absolute;
          left: 0;
          bottom: 25px;
          width: 100%;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          padding: 0 28px;
          .popularity-number{
            height:30px;
            font-size:22px;
            font-weight:400;
            line-height:30px;
          }
          .start-btn{
            width: 136px;
            height: 54px;
            border: 1px dashed #fff;
            text-align: center;
            line-height: 54px;
            font-size:30px;
          }
        }
      }
    }
  }
}
</style>
